import { Card } from "@scuf/common";
import { Chart } from "@scuf/charts";
import React, { useEffect, useState } from "react";
import { getValoresPeriodo } from "../../../services/services";
import formatDate from "../../../utils/formatDate";
import "../PAcido";
import { plotBackground } from "../../../config/colors";


export default function ProduccionAcido() {
  const [flujoAcido, setFlujoAcido] = useState({
    value: [],
    fecha: [],
    estado: [],
  });

  const [concentracionAcido, setConcentracionAcido] = useState({
    value: [],
    fecha: [],
    estado: [],
  });

  const [eficienciaConversion, setEficienciaConversion] = useState({
    value: [],
    fecha: [],
    estado: [],
  });


  // Fecha inicial y final
  const [date, setDate] = useState({ start: "19-01-2023", end: "25-01-2023" });

  // Objeto inicial de la peticion
  const initialFetch = {
    idSeccion: 5,
    secuencia: 18,
    ultimo: 0,
    frecuencia: 5,
    dias: 7,
  };

  useEffect(() => {
    // Peticion de datos al API
    async function fetchData() {
      // Solo nos traemos la data de la peticion
    const { data } = await getValoresPeriodo(initialFetch);

    populateflujoAcido(data);
    populateConcentracionAcido(data);
    populateEficienciaConversion(data);
      //#endregion
    }

    fetchData();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function populateflujoAcido(data) {
    const arrValues = [];
    const arrFechas = [];
    const arrData = data.filter(
      (element) => element.Detalle === "Flujo de Ácido Producto"
    );
    arrData.forEach((element) => {
      arrValues.push(element.Valor);
      arrFechas.push(formatDate(element.Fecha));
    });

    setDate({ start: arrFechas[0], end: arrFechas[arrFechas.length - 1] });

    setFlujoAcido({
      fecha: arrFechas,
      value: arrValues,
    });
  }

  function populateConcentracionAcido(data) {
    const arrValues = [];
    const arrFechas = [];
    const arrData = data.filter(
      (element) => element.Detalle === "Concentración de Ácido Producto"
    );
    arrData.forEach((element) => {
      arrValues.push(element.Valor);
      arrFechas.push(formatDate(element.Fecha));
    });

    setDate({ start: arrFechas[0], end: arrFechas[arrFechas.length - 1] });

    setConcentracionAcido({
      fecha: arrFechas,
      value: arrValues,
    });
  }

  function populateEficienciaConversion(data) {
    const arrValues = [];
    const arrFechas = [];
    const arrData = data.filter(
      (element) => element.Detalle === "Eficiencia Conversión PAS"
    );
    arrData.forEach((element) => {
      arrValues.push(element.Valor);
      arrFechas.push(formatDate(element.Fecha));
    });

    setDate({ start: arrFechas[0], end: arrFechas[arrFechas.length - 1] });

    setEficienciaConversion({
      fecha: arrFechas,
      value: arrValues,
    });
  }
  
 
  return (
    <>
       <Card>
        <Card.Content>
          <Chart
            plotBackgroundColor={plotBackground}
            title={"Perfil Producción Ácido"}
            subtitle={"Periodo " + date.start + " - " + date.end}
          >
            {/** -------------------------------- Flujo de Ácido Producto --------------------------------------- */}
            <Chart.Line
              name="Flujo de Ácido Producto"
              data={flujoAcido.value}
              yAxis={0}
            />
            {/** -------------------------------- Concentración de Ácido Producto --------------------------------------- */}
            <Chart.Line
              name="Concentración de Ácido Producto"
              data={concentracionAcido.value}
              yAxis={1}
            />
            {/** -------------------------------- Eficiencia Conversión PAS --------------------------------------- */}
            <Chart.Line
              name="Eficiencia Conversión PAS"
              data={eficienciaConversion.value}
              yAxis={1}
            />
           
            {/** -------------------------------- FECHAS --------------------------------------- */}
            <Chart.XAxis categories={flujoAcido.fecha} />

            <Chart.YAxis
              labelSuffix=" m3/h"
              title="Producción de Ácido, m3/h"
              lineWidth={2}
              lineColor="white"
            />

            <Chart.YAxis
              labelSuffix=" %"
              title="Concentración, % - Eficiencia PAS, %"
              lineWidth={2}
              opposite={true}
              lineColor="white"
              min={90}
              max={100}
            />

            <Chart.Tooltip valueSuffix="" />
          </Chart>
        </Card.Content>
      </Card>
    </>
  );
}
